export const MAX_TOTAL_SIZE_FILES = 20 * 1024 * 1024; // 20MB
